// oss预览url地址拆分
export function urlToFilePreviewFrom (url) {
    const form = Object.create(null);
    const lastPoint = url.lastIndexOf('.');
    const lastLine = url.lastIndexOf('_');
    const lastslash = url.lastIndexOf('/');
    form.fileName = url.slice(lastslash + 1, lastLine) + url.slice(lastPoint);
    form.fileId = url.slice(lastLine + 1, lastPoint);
    form.fileUrl = url;
    return form;
}